module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "ded"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_c('i', [_vm._v("To the memory of Dr. William Carlos Williams,")]), _vm._v(" "), _c('br'), _c('i', [_vm._v("whose words and thoughts inspired and")]), _vm._v(" "), _c('br'), _c('i', [_vm._v("helped so many of us in medicine;")]), _vm._v(" "), _c('br'), _c('i', [_vm._v("and to my family with much love.")])]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("—ROBERT COLES")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67a5b02c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/robe_9781595587800_oeb_ded_r1.vue
// module id = 63
// module chunks = 0